import { createRouter } from '@tanstack/react-router';
import { Route as rootRoute } from './routes/__root';
import { Route as galleryRoute } from './routes/gallery';
import { Route as hubRoute } from './routes/hub';
import { Route as indexRoute } from './routes/index';
import { Route as notFoundRoute } from './routes/not-found';
import { Route as trainingRoute } from './routes/training.$hazardId';
import { Route as quizRoute } from './routes/training.$hazardId.quiz';
import { Route as resultRoute } from './routes/training.$hazardId.result';

const routeTree = rootRoute.addChildren([
  indexRoute,
  hubRoute,
  trainingRoute,
  quizRoute,
  resultRoute,
  notFoundRoute,
  // scene catalog for review/capture — never in a production bundle
  ...(import.meta.env.DEV ? [galleryRoute] : []),
]);

export const router = createRouter({
  routeTree,
  defaultNotFoundComponent: () => {
    window.location.replace('/not-found');
    return null;
  },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
